// extracted by mini-css-extract-plugin
export var menuItem = "v_th d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "v_tj d_Z d_bz d_bP";
export var menuMainLink = "v_tk d_f0 d_dB";
export var menuLink = "v_tl d_f0 d_dB";
export var icon = "v_p9 d_bC d_bP";
export var divider = "v_tm d_bC d_bP";
export var sublinks = "v_tn";
export var link = "v_mC";
export var Link = "v_rl q_rl q_qC q_qX";